"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _colors = require("HubStyleTokens/colors");

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var Terms = _interopRequireWildcard(require("self-service-api/constants/Terms"));

var _PriceDisplay = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/pricing/PriceDisplay"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

var _publicPageUrls = require("pricing-pages-unified-ui/utils/publicPageUrls");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    font-size: 14px;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    font-size: 45px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    font-weight: 600;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var BillingCaption = _styledComponents.default.div.withConfig({
  displayName: "CalculatorPriceDisplayTile__BillingCaption",
  componentId: "sc-1xnbl8u-0"
})(["font-size:13px;font-weight:600;line-height:20px;text-transform:uppercase;", ";"], _responsiveBreakpoints.default.tablet(_templateObject()));

var MonthlyPrice = (0, _styledComponents.default)(_PriceDisplay.default).withConfig({
  displayName: "CalculatorPriceDisplayTile__MonthlyPrice",
  componentId: "sc-1xnbl8u-1"
})(["font-size:38px;font-weight:bold;", ";"], _responsiveBreakpoints.default.tablet(_templateObject2()));
var CrossedOutPrice = (0, _styledComponents.default)(_PriceDisplay.default).withConfig({
  displayName: "CalculatorPriceDisplayTile__CrossedOutPrice",
  componentId: "sc-1xnbl8u-2"
})(["text-decoration:line-through;"]);
var PriceBreakdownLink = (0, _styledComponents.default)(_UILink.default).withConfig({
  displayName: "CalculatorPriceDisplayTile__PriceBreakdownLink",
  componentId: "sc-1xnbl8u-3"
})(["", ";"], _responsiveBreakpoints.default.tablet(_templateObject3()));

var PerMonthSubtext = _styledComponents.default.span.withConfig({
  displayName: "CalculatorPriceDisplayTile__PerMonthSubtext",
  componentId: "sc-1xnbl8u-4"
})(["font-size:26px;font-weight:600;display:inline-flex;"]);

var StyledPriceText = _styledComponents.default.span.withConfig({
  displayName: "CalculatorPriceDisplayTile__StyledPriceText",
  componentId: "sc-1xnbl8u-5"
})(["font-size:18px;font-weight:400;"]);

var StyledCTAsWrapper = (0, _styledComponents.default)(_UIFlex.default).withConfig({
  displayName: "CalculatorPriceDisplayTile__StyledCTAsWrapper",
  componentId: "sc-1xnbl8u-6"
})(["margin-top:20px;margin-bottom:20px;text-align:center;button,a{display:block;min-width:200px;width:100%;line-height:24px;padding-top:16px;}"]);

var BillingTermSubtext = _styledComponents.default.span.withConfig({
  displayName: "CalculatorPriceDisplayTile__BillingTermSubtext",
  componentId: "sc-1xnbl8u-7"
})(["display:block;font-size:12px;color:", ";"], _colors.SLINKY);

var Bold = _styledComponents.default.span.withConfig({
  displayName: "CalculatorPriceDisplayTile__Bold",
  componentId: "sc-1xnbl8u-8"
})(["color:", ";font-weight:600;"], _colors.OBSIDIAN);

var getBreakdownLinkGAClassName = function getBreakdownLinkGAClassName(gaTrackingId) {
  return (0, _publicPageUrls.getGAClassName)(gaTrackingId + "-pricing-breakdown");
};

var CalculatorPriceDisplayTile = function CalculatorPriceDisplayTile(_ref) {
  var activeCurrencyCode = _ref.activeCurrencyCode,
      activeTerm = _ref.activeTerm,
      gaTrackingId = _ref.gaTrackingId,
      onViewPriceBreakdownClick = _ref.onViewPriceBreakdownClick,
      costToGetStarted = _ref.costToGetStarted,
      monthlyCostPrice = _ref.monthlyCostPrice,
      annualCostPrice = _ref.annualCostPrice,
      annualListPrice = _ref.annualListPrice,
      billingNameKey = _ref.billingNameKey,
      ctasComponent = _ref.ctasComponent,
      _ref$showTotalPriceAs = _ref.showTotalPriceAsterisk,
      showTotalPriceAsterisk = _ref$showTotalPriceAs === void 0 ? false : _ref$showTotalPriceAs,
      requiredOnboardingSubtext = _ref.requiredOnboardingSubtext,
      termSelectorComponent = _ref.termSelectorComponent;
  return _react.default.createElement("div", null, _react.default.createElement("div", {
    className: "m-top-4"
  }, termSelectorComponent), _react.default.createElement("div", {
    className: "m-bottom-5 m-top-8"
  }, _react.default.createElement(_FormattedJSXMessage.default, {
    message: activeTerm === Terms.MONTHLY ? "pricingPage.calculator.priceDisplay.pricingBilledMonthly_jsx" : "pricingPage.calculator.priceDisplay.pricingBilledAnnually_jsx",
    elements: {
      MonthlyPrice: MonthlyPrice,
      PerMonthSubtext: PerMonthSubtext,
      BillingTermSubtext: BillingTermSubtext,
      AnnualPrice: _PriceDisplay.default,
      Bold: Bold,
      // Only show crossed-out original price if list price and cost price are different
      CrossedOutPrice: annualListPrice === annualCostPrice ? function () {
        return null;
      } : CrossedOutPrice
    },
    options: {
      monthlyPriceProps: {
        price: monthlyCostPrice,
        dataSelenium: 'calculator-monthly-price',
        currencyCode: activeCurrencyCode
      },
      annualPriceProps: {
        price: annualCostPrice,
        currencyCode: activeCurrencyCode
      },
      crossedOutPriceProps: {
        price: annualListPrice,
        currencyCode: activeCurrencyCode
      }
    }
  })), _react.default.createElement(BillingCaption, {
    className: "p-x-5 m-bottom-1"
  }, billingNameKey ? _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator.priceDisplay.estimatedCost." + billingNameKey
  }) : _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator.priceDisplay.estimatedCost.default"
  })), _react.default.createElement(StyledPriceText, null, _react.default.createElement(_PriceDisplay.default, {
    currencyCode: activeCurrencyCode,
    price: costToGetStarted,
    dataSelenium: "calculator-total-price"
  }), showTotalPriceAsterisk && _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator.requiredOnboardingSubtext.asterisk"
  })), _react.default.createElement(StyledCTAsWrapper, {
    direction: "column",
    justify: "center",
    align: "center"
  }, ctasComponent), _react.default.createElement("div", null, _react.default.createElement(PriceBreakdownLink, {
    onClick: onViewPriceBreakdownClick,
    underline: true,
    className: getBreakdownLinkGAClassName(gaTrackingId)
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator.priceBreakdown.link",
    className: getBreakdownLinkGAClassName(gaTrackingId)
  }))), _react.default.createElement("div", {
    className: "m-top-4 p-x-5"
  }, requiredOnboardingSubtext));
};

CalculatorPriceDisplayTile.propTypes = {
  activeTerm: _propTypes.default.oneOf(Object.values(Terms || {})).isRequired,
  activeCurrencyCode: _propTypes.default.string.isRequired,
  onViewPriceBreakdownClick: _propTypes.default.func.isRequired,
  costToGetStarted: _propTypes.default.number.isRequired,
  monthlyCostPrice: _propTypes.default.number.isRequired,
  annualCostPrice: _propTypes.default.number.isRequired,
  annualListPrice: _propTypes.default.number.isRequired,
  billingNameKey: _propTypes.default.string,
  ctasComponent: _propTypes.default.node.isRequired,
  gaTrackingId: _propTypes.default.string.isRequired,
  showTotalPriceAsterisk: _propTypes.default.bool,
  requiredOnboardingSubtext: _propTypes.default.node,
  termSelectorComponent: _propTypes.default.node
};
var _default = CalculatorPriceDisplayTile;
exports.default = _default;
module.exports = exports.default;